import React, {Component, PropTypes} from 'react';
import { connect } from 'react-redux';
import {get} from 'lodash';
import IndeedConversionCode from '../IndeedConversionCode';
import PandoLogicTrackingPixel from '../PandoLogicTrackingPixel';
import JoveoTrackingPixel from '../JoveoTrackingPixel';

@connect(store => ({
  labels: get(store.labels, 'UnqualifiedMessage', {}),
}))
export default class UnqualifiedMessage extends Component {

  static propTypes = {
    labels: PropTypes.object.isRequired,
  }

 render() {

  return (
    <div className='rejection-body message-body'>
      <IndeedConversionCode conversionLabel='unquailified'  />
      <PandoLogicTrackingPixel conversionType='preliminary-unqualified'/>
      <JoveoTrackingPixel conversionType='preliminary-unqualified'/>
      <div dangerouslySetInnerHTML={{__html: this.props.labels.message}}></div>
    </div>
  );
 }
}



// WEBPACK FOOTER //
// ./shared/react/f_PreliminaryApplication/f_Application/r_ApplicationForm/r_CreateUserModal/f_UnqualifiedMessage/index.js